<template>
  <div>
    <HPhero/>
    <HPintro/>
    <HPservices/>
    <HPtransactions_alt/>
  </div>
</template>

<script>
import HPhero from "@/components/HPhero.vue";
import HPintro from "@/components/HPintro.vue";
import HPservices from "@/components/HPservices.vue";
import HPtransactions_alt from "@/components/HPtransactions_alt.vue";
import ContactForm from "@/components/ContactForm.vue";
export default {
  components: {
    HPhero,
    HPintro,
    HPservices,
    HPtransactions_alt,
    ContactForm
  }
};
</script>

<style lang="scss" scoped></style>
